import {
  IndicatorTissotFiltersBooleanValues,
  IndicatorTissotFiltersValues,
} from '@pages/pilotage-rh/indicators/indicator-types';

/**
 * Normalise les valeurs de filtres manquantes avec les valeurs par défaut
 * Cela évite des différences inutiles dans la modal de confirmation
 * Et comme on peut ajouter des nouveaux filtres, on doit gérer le cas où
 * les anciennes configurations n'ont pas ces filtres
 */
export const normalizeFilterValue = (original: any, current: any, path: string): any => {
  // Si original est défini ou que ce n'est pas un filtre, pas de normalisation
  if (original !== undefined || !path.startsWith('config.filters.')) {
    return original;
  }

  const filterKey = path.replace('config.filters.', '');

  // Essayer de trouver les valeurs par défaut pour ce filtre
  if (IndicatorTissotFiltersValues[filterKey as keyof typeof IndicatorTissotFiltersValues]) {
    return IndicatorTissotFiltersValues[filterKey as keyof typeof IndicatorTissotFiltersValues].map((d) => d.value);
  }

  if (IndicatorTissotFiltersBooleanValues[filterKey as keyof typeof IndicatorTissotFiltersBooleanValues]) {
    return IndicatorTissotFiltersBooleanValues[filterKey as keyof typeof IndicatorTissotFiltersBooleanValues].map(
      (d) => d,
    );
  }

  return original;
};
